'use strict';

(function () {
  'use strict';

  angular.module('msTracker').controller('TrackerEntriesCtrl', TrackerEntriesCtrl);

  TrackerEntriesCtrl.$inject = ['$log', 'moodTrackerSvc', 'moodTrackerDataMappingSvc', 'NotifyingSvc', 'userSvc'];

  /* @ngInject */
  function TrackerEntriesCtrl($log, moodTrackerSvc, moodTrackerDataMappingSvc, NotifyingSvc, userSvc) {
    var vm = this;
    vm.$onInit = activate;
    vm.title = 'TrackerEntriesCtrl';
    vm.trackers = {};

    vm.openRecordMultipleTrackerValuesModal = function (trackersArray, messageId, defaultMessage) {
      // add tracker labels to tracker data
      _.forEach(trackersArray, function (t) {
        var match = _.find(vm.trackers, { id: t.id });
        if (match) {
          t.title = match.title;
          t.negativeLabel = match.negativeLabel;
          t.positiveLabel = match.positiveLabel;
        }
      });
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'tracker/templates/record-multiple-tracker-values-modal.html',
        controller: 'RecordMultipleTrackerValuesModalCtrl',
        controllerAs: 'vm',
        inputs: {
          trackers: trackersArray,
          messageId: messageId,
          defaultMessage: defaultMessage
        },
        closeCallback: function closeCallback(result) {
          if (result) {
            NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.REFRESH_TRACKER);
          }
        }
      });
    };

    ////////////////

    function activate() {
      $log.debug(vm.title + ' activate');
      // initiate default queries

      updateEntries();
      NotifyingSvc.subscribe(NotifyingSvc.EVENTS.REFRESH_TRACKER, function () {
        return updateEntries();
      });
    }

    function updateEntries() {
      userSvc.getUser().then(function (user) {
        _getEntries(moment(user.createdOn).subtract(1, 'day'), moment().add(1, 'day')).then(function (entries) {
          return vm.trackerEntries = entries;
        });
      });
    }

    function _getEntries(fromDate, toDate) {
      return moodTrackerSvc.getDateRange(fromDate, toDate).then(function (data) {
        // save the tracker titles for display
        _.map(data, function (tracker) {
          vm.trackers[tracker.id] = {
            'id': tracker.id,
            'title': tracker.title,
            'negativeLabel': tracker.negativeLabel,
            'positiveLabel': tracker.positiveLabel
          };
        });
        return moodTrackerDataMappingSvc.mapEntries(moodTrackerDataMappingSvc.mapOldMoodScalingToNewScaling(data));
      });
    }
  }
})();